import React, {
  useState,
  useMemo,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from 'react';
import { Search, Room } from '@material-ui/icons';
import ReactMapGL, {
  MapboxGL,
  NavigationControl,
  FullscreenControl,
  ScaleControl,
  GeolocateControl,
  Marker,
  Popup,
} from 'react-map-gl';
// import mapboxgl from '!mapbox-gl';
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
// import mapboxgl from '!mapbox-gl';
import { AuthContext } from '../../context/AuthContext';
import axiosConn from '../../axiosConn';
import Topbar from '../../components/topbar/Topbar';
import TopbarPlayerMap from '../../components/topbarPlayerMap/TopbarPlayerMap';
import TopbarNotification from '../../components/topbarNotification/TopbarNotification';
import { Link } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { getLocationAndSave } from '../../utils/locationUtil';
import { useGetPosts } from '../../hooks/useGetPosts';
import getDistance from '../../utils/getDistance';
import Post from '../../components/post/Post';
import { useTheme } from '../../context/ThemeContext';
import preciseFormat from '../../utils/preciseFormat';
import VisibilityIcon from '@mui/icons-material/Visibility';
import useMobileView from '../../hooks/useMobileView';
import useUpdatePostViews from '../../hooks/useUpdatePostViews';
import { useLocation } from 'react-router-dom';
import { WebMercatorViewport } from 'viewport-mercator-project';
import { SocketContext } from '../../context/socket';
import PlayerMarkers from '../../components/playerMarkers/PlayerMarkers';
import getDistanceFromLatLonInMeters from '../../utils/getDistanceFromLatLonInMeters';

import './playermap.css';

const minZoom = 3; // Allow for a more zoomed-out view
const maxZoom = 17; // Allow for a closer view

export default function PlayerMapPage() {
  // console.log('PlayerMapPage re-rendered');
  const { player } = useContext(AuthContext);
  const mobileView = useMobileView();
  const [latitude, SetLatitude] = useState(null);
  const [longitude, SetLongitude] = useState(null);
  const [accuracy, SetAccuracy] = useState(null);
  const [timestamp, SetTimestamp] = useState(null);
  const [radius, setRadius] = useState(50);
  const [initialRadius, setInitialRadius] = useState(radius);
  const [postRadiusSet, setPostRadiusSet] = useState(false);
  const [unit, setUnit] = useState('mi');
  const [playersWithin, setPlayersWithin] = useState({});
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [zoom, setZoom] = useState(null);
  const [initialZoom, setInitialZoom] = useState(zoom);
  const [getPosition, setGetPosition] = useState(true);
  const { socket: socket2 } = useContext(SocketContext);
  const [lastFetchLocation, setLastFetchLocation] = useState({
    lat: null,
    lon: null,
  });
  const [fetchLat, setFetchLat] = useState(null);
  const [fetchLon, setFetchLon] = useState(null);
  const lastSentLocation = useRef({ lat: null, lon: null });
  const lastMovementTime = useRef(Date.now());

  const handleSelectPlayer = useCallback(
    (player) => setSelectedPlayer(player),
    [],
  );
  const initialViewport = useRef(null);
  //   const [address, SetAddress] = useState('');
  const [viewport, setViewport] = useState({
    latitude: 25.774772,
    longitude: -80.185942,
    zoom: 4,
    width: '100vw',
    height: '100vh',
    // center: [longitude, latitude],
  });
  const [calculatedZoom, setCalculatedZoom] = useState(0);
  const isInitialLoad = useRef(true); // Track if this is the initial load

  const [page, setPage] = useState(1);
  const [postItems, setPostItems] = useState([]);
  const [socketPostIds, setSocketPostIds] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const location = useLocation();
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const parent = queryParams.get('parent');

  const calculateBoundingBox = (posts) => {
    if (!posts || posts.length === 0) return null;

    // Filter out posts without valid location or coordinates
    const validPosts = posts.filter(
      (post) =>
        post.location &&
        Array.isArray(post.location.coordinates) &&
        post.location.coordinates.length === 2 &&
        typeof post.location.coordinates[0] === 'number' &&
        typeof post.location.coordinates[1] === 'number',
    );

    if (validPosts.length === 0) return null; // Return null if no valid posts

    const lats = validPosts.map((post) => post.location.coordinates[1]); // Latitude
    const lons = validPosts.map((post) => post.location.coordinates[0]); // Longitude

    const minLat = Math.min(...lats);
    const maxLat = Math.max(...lats);
    const minLon = Math.min(...lons);
    const maxLon = Math.max(...lons);

    return [
      [minLon, minLat],
      [maxLon, maxLat],
    ]; // Southwest and Northeast corners
  };

  const radiusPaddingFactor = 3; // Try 1.1–1.2 for a comfortable fit
  const MOVEMENT_THRESHOLD_METERS = 1;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000); // update every second
    return () => clearInterval(interval);
  }, []);

  const calculateViewport = (
    boundingBox,
    mapWidth,
    mapHeight,
    radius,
    centerLat,
  ) => {
    const viewport = new WebMercatorViewport({
      width: mapWidth,
      height: mapHeight,
    }).fitBounds(boundingBox, { padding: 50 });

    // Convert radius to meters if needed
    const radiusInMeters = unit === 'mi' ? radius * 1609.34 : radius * 1000;

    // Calculate zoom so that the diameter (2*radius) fits in the map width
    const zoomForRadius = Math.log2(
      (156543.03392 *
        Math.cos((viewport.latitude * Math.PI) / 180) *
        mapWidth) /
        (radiusInMeters * 2 * radiusPaddingFactor),
    );

    // Clamp zoom
    const clampedZoom = Math.max(minZoom, Math.min(maxZoom, zoomForRadius));

    setCalculatedZoom(clampedZoom);

    return {
      latitude: viewport.latitude,
      longitude: viewport.longitude,
      zoom:
        zoom !== initialZoom && radius === initialRadius ? zoom : clampedZoom,
    };
  };
  // const handlePlayerLocationUpdate = (updatedPlayer) => {
  //   console.log(
  //     'Received location update for:',
  //     updatedPlayer.playerId,
  //     updatedPlayer.lastLocation.coordinates[0],
  //     updatedPlayer.lastLocation.coordinates[1],
  //   );

  //   setPlayersWithin((prevPlayers) => {
  //     console.log('Previous playersWithin:', prevPlayers);

  //     // Find the existing player in the array
  //     const existingPlayer = prevPlayers?.find(
  //       (player) => player.playerId === updatedPlayer.playerId,
  //     );

  //     if (existingPlayer) {
  //       console.log(
  //         'Existing player found:',
  //         existingPlayer.playerId,
  //         'Existing coordinates:',
  //         existingPlayer.lastLocation.coordinates,
  //       );

  //       // Only update if the player's location has changed
  //       if (
  //         existingPlayer.lastLocation.coordinates[0] ===
  //           updatedPlayer.lastLocation.coordinates[0] &&
  //         existingPlayer.lastLocation.coordinates[1] ===
  //           updatedPlayer.lastLocation.coordinates[1]
  //       ) {
  //         console.log(
  //           'No location change detected for:',
  //           updatedPlayer.playerId,
  //         );
  //         return prevPlayers; // No changes, return the previous state
  //       } else {
  //         console.log(
  //           'Location change detected for:',
  //           updatedPlayer.playerId,
  //           'New coordinates:',
  //           updatedPlayer.lastLocation.coordinates,
  //         );
  //       }
  //     } else {
  //       console.log(
  //         'Player not found in playersWithin, adding new player:',
  //         updatedPlayer.playerId,
  //       );
  //     }

  //     // Update the player or add a new one
  //     const updatedPlayers = existingPlayer
  //       ? prevPlayers.map((player) =>
  //           player.playerId === updatedPlayer.playerId
  //             ? {
  //                 ...player, // Preserve existing player data
  //                 lastLocation: updatedPlayer.lastLocation, // Update only the lastLocation
  //               }
  //             : player,
  //         )
  //       : [
  //           ...prevPlayers,
  //           {
  //             ...updatedPlayer, // Add the new player
  //           },
  //         ];

  //     console.log('Updated playersWithin:', updatedPlayers);
  //     return updatedPlayers; // Return the updated state
  //   });
  // };

  useEffect(() => {
    const handleUnload = () => {
      if (latitude && longitude && player?.token) {
        const data = {
          latitude,
          longitude,
          accuracy,
          timestamp,
          token: player.token, // Include token in body for backend auth
        };
        const result = navigator.sendBeacon(
          '/api/players/lastLocation',
          JSON.stringify(data),
        );
        if (result) {
          console.log('[sendBeacon] Location beacon queued for sending.');
        } else {
          console.log('[sendBeacon] Failed to queue location beacon.');
        }
      }
    };
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [latitude, longitude, accuracy, timestamp, player?.token]);

  useEffect(() => {
    let heartbeatId;
    let mounted = true;

    async function sendHeartbeat() {
      if (!mounted) return;
      try {
        await getLocationAndSave(
          SetLatitude,
          SetLongitude,
          SetAccuracy,
          SetTimestamp,
          player,
        );
        // Optionally, you can log or handle success here
        console.log('Heartbeat location sent to backend');
      } catch (err) {
        console.log('Heartbeat location update failed:', err);
      }
      heartbeatId = setTimeout(sendHeartbeat, 30000); // 30 seconds
    }

    sendHeartbeat();

    return () => {
      mounted = false;
      clearTimeout(heartbeatId);
    };
  }, [player]);

  const handlePlayerLocationUpdate = (updatedPlayer) => {
    // console.log(
    //   'Received location update for:',
    //   updatedPlayer.playerId,
    //   updatedPlayer.lastLocation.coordinates[0],
    //   updatedPlayer.lastLocation.coordinates[1],
    // );

    setPlayersWithin((prevPlayers) => {
      // console.log('Previous playersWithin:', prevPlayers);

      const existingPlayer = prevPlayers[updatedPlayer.playerId];
      let newLastMovementTime = existingPlayer?.lastMovementTime || Date.now();

      if (existingPlayer) {
        // console.log(
        //   'Existing player found:',
        //   existingPlayer.playerId,
        //   'Existing coordinates:',
        //   existingPlayer.lastLocation.coordinates,
        // );

        // Calculate distance between previous and new location
        const [prevLon, prevLat] = existingPlayer.lastLocation.coordinates;
        const [newLon, newLat] = updatedPlayer.lastLocation.coordinates;
        const distance = getDistanceFromLatLonInMeters(
          prevLat,
          prevLon,
          newLat,
          newLon,
        );

        if (distance < MOVEMENT_THRESHOLD_METERS) {
          console.log(
            `Movement (${distance.toFixed(2)}m) below threshold for:`,
            updatedPlayer.playerId,
          );
          // Not enough movement, ignore
          return prevPlayers;
        }

        if (prevLon === newLon && prevLat === newLat) {
          // console.log(
          //   'No location change detected for:',
          //   updatedPlayer.playerId,
          // );
          return prevPlayers;
        } else {
          // Location changed, update lastMovementTime
          newLastMovementTime = Date.now();
          console.log(
            'Location change detected for:',
            updatedPlayer.playerId,
            'New coordinates:',
            updatedPlayer.lastLocation.coordinates,
            `Distance moved: ${distance.toFixed(2)}m`,
          );
        }
      } else {
        newLastMovementTime = Date.now();
        console.log(
          'Player not found in playersWithin, adding new player:',
          updatedPlayer.playerId,
        );
      }

      const updatedPlayers = {
        ...prevPlayers,
        [updatedPlayer.playerId]: {
          ...existingPlayer,
          ...updatedPlayer,
          lastLocation: updatedPlayer.lastLocation,
          lastMovementTime: newLastMovementTime,
        },
      };

      // console.log('Updated playersWithin:', updatedPlayers);
      return updatedPlayers;
    });
  };

  useEffect(() => {
    let mounted = true;
    if (latitude && longitude) {
      const distance = getDistance(
        lastFetchLocation.lat,
        lastFetchLocation.lon,
        latitude,
        longitude,
        unit, // 'mi' or 'km'
      );
      // Only trigger if threshold is crossed
      if (!mounted) return;
      if (
        lastFetchLocation.lat === null ||
        lastFetchLocation.lon === null ||
        distance > 1 // 1 mile or your chosen threshold
      ) {
        setLastFetchLocation({ lat: latitude, lon: longitude });
        setFetchLat(latitude); // This triggers useGetPosts
        setFetchLon(longitude);
      }
    }
    return () => {
      mounted = false; // Cleanup function to prevent memory leaks
      // Cleanup function to prevent memory leaks
    };
    // Only depend on latitude, longitude, unit, and lastFetchLocation
    // Do NOT include lastFetchLocation.lat/lon in the dependency array, or you'll get stuck in a loop!
  }, [latitude, longitude, unit]);

  // Set up socket listeners
  useEffect(() => {
    const handlePlayerLocationUpdateWrapper = (updatedPlayer) => {
      // console.log('updatedPlayer:', updatedPlayer);
      handlePlayerLocationUpdate(updatedPlayer);
    };

    socket2.on('getPlayerLocationUpdate', handlePlayerLocationUpdateWrapper);

    return () => {
      socket2.off('getPlayerLocationUpdate', handlePlayerLocationUpdateWrapper);
    };
  }, [socket2]);

  // useEffect(() => {
  //   let mounted = true;

  //   // Function to update the current player's location
  //   const updateCurrentPlayerLocation = async () => {
  //     if (!mounted) return;

  //     await getLocationAndSave(
  //       SetLatitude,
  //       SetLongitude,
  //       SetAccuracy,
  //       SetTimestamp,
  //       player,
  //     ).then(() => {
  //       const latitude = JSON.parse(secureLocalStorage.getItem('latitude'));
  //       const longitude = JSON.parse(secureLocalStorage.getItem('longitude'));

  //       if (latitude && longitude) {
  //         // Emit the updated location to the server
  //         socket2.emit('updatePlayerLocation', {
  //           playerId: player.data.player.playerId,
  //           _id: player.data.player._id,
  //           location: {
  //             coordinates: [longitude, latitude],
  //           },
  //         });
  //       }
  //     });
  //   };

  useEffect(() => {
    let mounted = true;
    let timeoutId;

    const updateCurrentPlayerLocation = () => {
      console.log('[Location] Updating current player location');
      if (!mounted) return;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('Accuracy (meters):', position.coords.accuracy);

          const newLat = position.coords.latitude;
          const newLon = position.coords.longitude;

          console.log('New location:', newLat, newLon);

          // Calculate distance between previous and new location
          const prevLat = lastSentLocation.current.lat;
          const prevLon = lastSentLocation.current.lon;
          let distance = 0;
          if (prevLat !== null && prevLon !== null) {
            distance = getDistanceFromLatLonInMeters(
              prevLat,
              prevLon,
              newLat,
              newLon,
            );
            console.log(
              `[Location] Distance from last sent: ${distance.toFixed(2)}m`,
            );
          }

          // Only emit if significant movement occurred
          if (
            prevLat === null ||
            prevLon === null ||
            distance >= MOVEMENT_THRESHOLD_METERS
          ) {
            console.log(
              '[Location] Moved More Than THRESHOLD:',
              newLat,
              newLon,
              'emitting update',
            );
            socket2.emit('updatePlayerLocation', {
              playerId: player.data.player.playerId,
              _id: player.data.player._id,
              location: {
                coordinates: [newLon, newLat],
              },
            });
            lastSentLocation.current = { lat: newLat, lon: newLon };
            lastMovementTime.current = Date.now();
            console.log(
              `[Location] Moved: sent update at ${newLat}, ${newLon} (interval will be 5s if moving), distance: ${distance.toFixed(
                2,
              )}m`,
            );
          } else {
            console.log('[Location] No significant movement detected');
            // No significant movement, but check if it's been more than 30s since last movement
            const now = Date.now();
            if (now - lastMovementTime.current >= 30000) {
              console.log(
                `[Location] No movement detected for >30s, interval now 15s`,
              );
            } else {
              console.log(
                `[Location] No movement detected, interval remains 5s`,
              );
            }
          }
        },
        (error) => {
          console.error('Geolocation error:', error);
        },
        { enableHighAccuracy: true },
      );
    };
    // Adaptive interval: 5s if moved in last 30s, else 15s
    const adaptiveInterval = () => {
      console.log('[Adaptive] Calculating adaptive interval');
      const now = Date.now();
      const interval = now - lastMovementTime.current < 30000 ? 5000 : 15000;
      // Debug: show which interval is being used
      if (interval === 5000) {
        console.log('[Adaptive] Using 5s interval (recent movement)');
      } else {
        console.log('[Adaptive] Using 15s interval (no recent movement)');
      }
      return interval;
    };

    function scheduleNext() {
      console.log('[Location] Scheduling next update');
      updateCurrentPlayerLocation();
      timeoutId = setTimeout(scheduleNext, adaptiveInterval());
    }

    scheduleNext();

    return () => {
      mounted = false;
      clearTimeout(timeoutId);
    };
  }, [socket2, player.data.player.playerId, player.data.player._id]);

  useEffect(() => {
    const lat = parseFloat(queryParams.get('lat'));
    const lon = parseFloat(queryParams.get('lon'));
    const parent = queryParams.get('parent');

    if (parent === 'post' && !isNaN(lat) && !isNaN(lon)) {
      SetLatitude(lat);
      SetLongitude(lon);
    }
  }, [location.search, queryParams]);

  const error = () => {
    console.log('error geolocation called.');
    setGetPosition(false);
  };

  const onSuccess = (data) => {
    // console.log('data: ', data);
  };

  const onError = (err) => {
    // console.log('err: ', err);
  };

  const { isLoading, data, status } = useGetPosts(
    onSuccess,
    onError,
    player,
    null,
    page,
    'posts',
    null,
    // trigger,
    true, //fetchAll
    radius,
    unit,
    fetchLat,
    fetchLon,
  );

  // console.log(data?.length);
  const processedPosts = useMemo(() => {
    if (status === 'success' && data) {
      const newPosts = data.filter(
        (post) => !socketPostIds.includes(post._id), // Exclude posts already in socketPostIds
      );

      // Sort the posts by date
      return newPosts.sort((a, b) => {
        const dateA = a.repostedAt
          ? new Date(a.repostedAt)
          : new Date(a.createdAt);
        const dateB = b.repostedAt
          ? new Date(b.repostedAt)
          : new Date(b.createdAt);
        return dateB - dateA;
      });
    }
    return [];
  }, [status, data, socketPostIds]);

  useEffect(() => {
    if (processedPosts.length > 0) {
      setPostItems((prevPostItems) => {
        // Check if the new posts are different from the current state
        const isDifferent =
          processedPosts.length !== prevPostItems.length ||
          !processedPosts.every(
            (post, index) => post._id === prevPostItems[index]._id,
          );

        if (isDifferent) {
          console.log('Updating postItems with new posts.');
          return processedPosts;
        }

        return prevPostItems; // No update needed
      });
    } else if (status === 'success' && processedPosts.length === 0) {
      console.log('No posts found within the radius.');
      setPostItems([]); // Clear postItems if no posts are found
    }
  }, [processedPosts, status]);

  useEffect(() => {
    if (isInitialLoad.current || radius || unit) {
      isInitialLoad.current = false; // Mark as no longer the initial load

      if (postItems && postItems.length > 0) {
        const boundingBox = calculateBoundingBox(postItems);
        if (boundingBox) {
          const { latitude, longitude, zoom } = calculateViewport(
            boundingBox,
            window.innerWidth, // Map width
            window.innerHeight, // Map height
            radius, // Pass radius to adjust zoom dynamically
          );

          // Prevent overriding zoom if the player is zooming in
          setViewport((prevViewport) => {
            // console.log('zoom:', zoom, 'Calculated Zoom:', calculatedZoom);

            if (zoom > calculatedZoom) {
              return prevViewport; // Skip updating if zoom is greater than calculatedZoom
            }

            return {
              ...prevViewport,
              latitude,
              longitude,
              zoom: Math.max(minZoom, Math.min(maxZoom, zoom)), // Clamp zoom between minZoom and maxZoom
            };
          });
        }
      }
    }
  }, [postItems, radius, unit, calculatedZoom]);

  // useEffect(() => {
  //   // Combine posts and players for bounding box calculation
  //   const playerArray = Object.values(playersWithin);
  //   // console.log('playerArray:', playerArray);
  //   // console.log('postItems:', postItems);
  //   const allMapItems = [
  //     ...postItems.filter(
  //       (post) =>
  //         post.location &&
  //         Array.isArray(post.location.coordinates) &&
  //         post.location.coordinates.length === 2,
  //     ),
  //     ...playerArray
  //       .filter(
  //         (player) =>
  //           player.lastLocation &&
  //           Array.isArray(player.lastLocation.coordinates) &&
  //           player.lastLocation.coordinates.length === 2,
  //       )
  //       .map((player) => ({
  //         location: { coordinates: player.lastLocation.coordinates },
  //       })),
  //   ];

  //   // console.log('allMapItems:', allMapItems);
  //   if (allMapItems.length === 0) {
  //     console.log('No posts or players to calculate bounding box.');
  //     return;
  //   }

  //   try {
  //     const boundingBox = calculateBoundingBox(allMapItems);
  //     // console.log('Combined bounding box:', boundingBox);

  //     if (boundingBox) {
  //       const { latitude, longitude, zoom } = calculateViewport(
  //         boundingBox,
  //         window.innerWidth,
  //         window.innerHeight,
  //         radius,
  //       );

  //       // Prevent overriding zoom if the player is zooming in
  //       setViewport((prevViewport) => {
  //         // console.log('zoom:', zoom, 'Calculated Zoom:', calculatedZoom);
  //         if (zoom > calculatedZoom) {
  //           return prevViewport; // Skip updating if zoom is greater than calculatedZoom
  //         }
  //         return {
  //           ...prevViewport,
  //           latitude,
  //           longitude,
  //           zoom: Math.max(minZoom, Math.min(maxZoom, zoom)), // Clamp zoom between minZoom and maxZoom
  //         };
  //       });
  //     } else {
  //       console.log('No valid bounding box could be calculated.');
  //     }
  //   } catch (err) {
  //     console.log('Error calculating combined bounding box or viewport:', err);
  //   }
  // }, [postItems, playersWithin, radius, unit, calculatedZoom]);

  // console.log('Post items:', postItems.length);
  useEffect(() => {
    let mounted = true;
    const options = {
      enableHighAccuracy: true,
    };

    const getData = async () => {
      if (!mounted) return;

      const lat = parseFloat(queryParams.get('lat'));
      const lon = parseFloat(queryParams.get('lon'));

      // If lat, lon, and parent query parameters are present, skip getLocationAndSave
      if (parent === 'post' && !isNaN(lat) && !isNaN(lon)) {
        console.log('Using queryParams for latitude and longitude');
        if (!postRadiusSet) {
          setRadius(20);
          setPostRadiusSet(true);
        }
        try {
          if (!getPosition || radius < 0 || radius === '') {
            console.log('Location not shared or radius not positive');
            return;
          }

          const res = await axiosConn.get(
            `/players/players-within/${radius}/center/${lat},${lon}/unit/${
              unit ? unit : 'mi'
            }`,
            {
              headers: {
                Authorization: `Bearer ${player.token}`,
              },
            },
          );

          if (!mounted) return;

          // setPlayersWithin(res.data.data.data);
          // Convert array to object
          const playersObj = {};
          for (const player of res.data.data.data) {
            // Preserve lastMovementTime if player already exists in state
            const prevPlayer = playersWithin[player.playerId];
            playersObj[player.playerId] = {
              ...player,
              lastMovementTime: prevPlayer?.lastMovementTime || Date.now(),
            };
          }
          // console.log('playersObj:', playersObj);
          setPlayersWithin(playersObj);
          secureLocalStorage.setItem(
            'playersWithin',
            JSON.stringify(res.data.data.data),
          );

          // Calculate the bounding box for the initial viewport
          const boundingBox = calculateBoundingBox(res.data.data.data);

          if (!initialViewport.current && boundingBox) {
            console.log('Setting initial viewport using calculateViewport');
            const {
              latitude: latViewport,
              longitude: lonViewport,
              zoom,
            } = calculateViewport(
              boundingBox,
              window.innerWidth, // Map width
              window.innerHeight, // Map height
              radius, // Pass radius to adjust zoom dynamically
            );

            const newViewport = {
              latitude: latViewport,
              longitude: lonViewport,
              zoom,
              width: '100vw',
              height: '100vh',
            };

            initialViewport.current = newViewport;
            setViewport(newViewport);
          }
        } catch (err) {
          console.log(err);
        }
        return; // Exit early since we handled the queryParams case
      }

      // If no queryParams, proceed with getLocationAndSave
      await getLocationAndSave(
        SetLatitude,
        SetLongitude,
        SetAccuracy,
        SetTimestamp,
        player,
      ).then(async () => {
        const latitude = JSON.parse(secureLocalStorage.getItem('latitude'));
        const longitude = JSON.parse(secureLocalStorage.getItem('longitude'));

        try {
          if (
            !latitude ||
            !longitude ||
            !getPosition ||
            radius < 0 ||
            radius === ''
          ) {
            console.log(
              'null latitude and longitude or location not shared or radius not positive',
            );
            return;
          }

          const res = await axiosConn.get(
            `/players/players-within/${radius}/center/${latitude},${longitude}/unit/${
              unit ? unit : 'mi'
            }`,
            {
              headers: {
                Authorization: `Bearer ${player.token}`,
              },
            },
          );

          if (!mounted) return;

          // setPlayersWithin(res.data.data.data);
          // Convert array to object
          const playersObj = {};
          for (const player of res.data.data.data) {
            // Preserve lastMovementTime if player already exists in state
            const prevPlayer = playersWithin[player.playerId];
            playersObj[player.playerId] = {
              ...player,
              lastMovementTime: prevPlayer?.lastMovementTime || Date.now(),
            };
          }
          // console.log('playersObj:', playersObj);
          setPlayersWithin((prevPlayers) => {
            const playersObj = {};
            for (const player of res.data.data.data) {
              const prevPlayer = prevPlayers[player.playerId];
              if (
                prevPlayer &&
                prevPlayer.lastLocation.coordinates[0] ===
                  player.lastLocation.coordinates[0] &&
                prevPlayer.lastLocation.coordinates[1] ===
                  player.lastLocation.coordinates[1] &&
                prevPlayer.profilePhoto === player.profilePhoto
              ) {
                playersObj[player.playerId] = prevPlayer; // Reuse previous object
              } else {
                playersObj[player.playerId] = player; // Use new/changed object
              }
            }
            // Optionally, log for debugging:
            // console.log('playersObj (with reuse):', playersObj);
            return playersObj;
          });
          secureLocalStorage.setItem(
            'playersWithin',
            JSON.stringify(res.data.data.data),
          );

          // Calculate the bounding box for the initial viewport
          const boundingBox = calculateBoundingBox(res.data.data.data);
          // console.log('Bounding box:', boundingBox);
          if (!initialViewport.current && boundingBox) {
            console.log('Setting initial viewport using calculateViewport');
            const {
              latitude: latViewport,
              longitude: lonViewport,
              zoom,
            } = calculateViewport(
              boundingBox,
              window.innerWidth, // Map width
              window.innerHeight, // Map height
              radius, // Pass radius to adjust zoom dynamically
            );

            const newViewport = {
              latitude: latViewport,
              longitude: lonViewport,
              zoom,
              width: '100vw',
              height: '100vh',
            };

            initialViewport.current = newViewport;
            console.log('Initial viewport:', initialViewport.current);
            setViewport(newViewport);
          }
        } catch (err) {
          console.log(err);
        }
      });
    };

    getData();

    return () => {
      mounted = false;
      secureLocalStorage.removeItem('playersWithin');
    };
  }, [queryParams, player.token, radius, unit, getPosition, parent]);
  // //   console.log(latitude, longitude, accuracy, timestamp);

  // useEffect(() => {
  //   let mounted = true;
  //   const options = {
  //     enableHighAccuracy: true,
  //   };

  //   const getData = async () => {
  //     if (!mounted) return;

  //     const lat = parseFloat(queryParams.get('lat'));
  //     const lon = parseFloat(queryParams.get('lon'));

  //     // If lat, lon, and parent query parameters are present, skip getLocationAndSave
  //     if (parent === 'post' && !isNaN(lat) && !isNaN(lon)) {
  //       console.log('Using queryParams for latitude and longitude');
  //       if (!postRadiusSet) {
  //         setRadius(20);
  //         setPostRadiusSet(true);
  //       }
  //       try {
  //         if (!getPosition || radius < 0 || radius === '') {
  //           console.log('Location not shared or radius not positive');
  //           return;
  //         }

  //         const res = await axiosConn.get(
  //           `/players/players-within/${radius}/center/${lat},${lon}/unit/${
  //             unit ? unit : 'mi'
  //           }`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${player.token}`,
  //             },
  //           },
  //         );

  //         if (!mounted) return;

  //         // Convert array to object
  //         const playersObj = {};
  //         for (const player of res.data.data.data) {
  //           playersObj[player.playerId] = player;
  //         }
  //         // console.log('playersObj:', playersObj);
  //         setPlayersWithin(playersObj);
  //         // secureLocalStorage.setItem(
  //         //   'playersWithin',
  //         //   JSON.stringify(res.data.data.data),
  //         // );
  //       } catch (err) {
  //         console.log(err);
  //       }
  //       return; // Exit early since we handled the queryParams case
  //     }

  //     // If no queryParams, proceed with getLocationAndSave
  //     await getLocationAndSave(
  //       SetLatitude,
  //       SetLongitude,
  //       SetAccuracy,
  //       SetTimestamp,
  //       player,
  //     ).then(async () => {
  //       const latitude = JSON.parse(secureLocalStorage.getItem('latitude'));
  //       const longitude = JSON.parse(secureLocalStorage.getItem('longitude'));

  //       try {
  //         if (
  //           !latitude ||
  //           !longitude ||
  //           !getPosition ||
  //           radius < 0 ||
  //           radius === ''
  //         ) {
  //           console.log(
  //             'null latitude and longitude or location not shared or radius not positive',
  //           );
  //           return;
  //         }

  //         const res = await axiosConn.get(
  //           `/players/players-within/${radius}/center/${latitude},${longitude}/unit/${
  //             unit ? unit : 'mi'
  //           }`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${player.token}`,
  //             },
  //           },
  //         );

  //         if (!mounted) return;

  //         // Convert array to object
  //         const playersObj = {};
  //         for (const player of res.data.data.data) {
  //           playersObj[player.playerId] = player;
  //         }
  //         // console.log('playersObj:', playersObj);
  //         setPlayersWithin(playersObj);
  //         // secureLocalStorage.setItem(
  //         //   'playersWithin',
  //         //   JSON.stringify(res.data.data.data),
  //         // );
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     });
  //   };

  //   getData();

  //   return () => {
  //     mounted = false;
  //     secureLocalStorage.removeItem('playersWithin');
  //   };
  // }, [queryParams, player.token, radius, unit, getPosition, parent]);

  // const playersWithin2 = JSON.parse(
  //   secureLocalStorage.getItem('playersWithin'),
  // );
  // // console.log(playersWithin2);

  useEffect(() => {
    const listener = (e) => {
      if (e.key === 'Escape') {
        setSelectedPlayer(null);
      }
    };
    window.addEventListener('keydown', listener);
    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, []);

  // console.log(filteredPostItems);
  const getOffsetCoordinates = (latitude, longitude, index) => {
    const offset = 0.0001; // Offset value for staggering markers
    const latOffset =
      latitude + (index % 2 === 0 ? offset : -offset) * (index + 1);
    const lonOffset =
      longitude + (index % 2 === 0 ? -offset : offset) * (index + 1);
    return [latOffset, lonOffset];
  };
  const handleDeletePost = (postId) => {
    setPostItems((prevPostItems) =>
      prevPostItems.filter((post) => post._id !== postId),
    );
  };

  const filteredPostsComponents = postItems.map((post, index) => {
    const [latOffset, lonOffset] = getOffsetCoordinates(
      post.location.coordinates[1],
      post.location.coordinates[0],
      index,
    );
    return (
      <Marker key={post._id} longitude={lonOffset} latitude={latOffset}>
        <button
          className="marker-btn2"
          onClick={(e) => {
            e.preventDefault();
            setSelectedPost(post);
          }}
          style={{
            position: 'relative',
            border: 'none',
            padding: '0',
            cursor: 'pointer',
            background: 'none',
            width: '50px',
            height: '70px',
          }}
          aria-label={`Post by ${post.playerId}`}
          title={`Post by ${post.playerId} "${post.desc.trim()}"`}
        >
          {post.img &&
          (post.img.endsWith('.mp4') || post.img.endsWith('.mov')) ? (
            <video
              src={post.img}
              // autoPlay
              muted
              loop
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 1,
              }}
            />
          ) : (
            <div
              style={{
                backgroundImage: `url(${
                  post.img ||
                  'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                })`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1,
              }}
            />
          )}
        </button>
      </Marker>
    );
  });
  // console.log(filteredPostItems);
  // useEffect(() => {
  //   console.log('Updated playersWithin state:', playersWithin);
  // }, [playersWithin]);

  // console.log('PlayerMapPage re-rendered');
  // console.log('playersWithin:', playersWithin);
  // console.log('player:', player);

  return (
    <>
      <div>
        {/* <Topbar parent={'PlayerMap'} /> */}
        <TopbarPlayerMap
          radius={radius}
          setRadius={setRadius}
          unit={unit ? unit : 'mi'}
          setUnit={setUnit}
          parent={'PlayerMap'}
          setZoom={setZoom}
          getPosition={getPosition}
        />
      </div>
      {/* {mobileView && <TopbarNotification />} */}
      <div className="full">
        <ReactMapGL
          {...viewport}
          mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
          mapStyle="mapbox://styles/joegalaxydotnet/clmquop4a04vw01phe5fi2sdq"
          onMove={(event) => {
            // console.log('Current Zoom:', event.viewState.zoom); // Log the zoom value
            setZoom(event.viewState.zoom);
            setViewport(event.viewport);
          }}
          // zoom={zoom}
        >
          <NavigationControl
            onViewportChange={(event) => {
              setViewport(event.viewport);
            }}
            position="top-left"
            // visualizePitch={true}
          />
          <GeolocateControl
            position="top-left"
            trackUserLocation={true}
            showUserHeading={true}
            showUserLocation={true}
            showAccuracyCircle={true}
            onTrackUserLocationStart={(evt) => {
              // console.log(evt);
              //setLatitude
              //setLongitude
            }}
          />
          <FullscreenControl position="top-left" />
          <ScaleControl
            unit={unit === 'mi' || unit === '' ? 'imperial' : 'metric'}
          />
          {/* {parent !== 'post' && (
            <Link
              to={`/profile/${player.data.player?.playerId}`}
              className="mmenu_header hover3"
            >
              <Marker latitude={latitude} longitude={longitude}>
                <button className="marker-btn2">
                  <img
                    // src="https://res.cloudinary.com/joegalaxy/image/upload/v1695177384/Map_marker_fymyi0.svg"
                    src={
                      player.data.player?.profilePhoto
                        ? player.data.player?.profilePhoto
                        : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                    }
                    alt={player.data.player?.playerId}
                    title={player.data.player?.playerId}
                  />
                </button>
              </Marker>
            </Link>
          )} */}
          {/* SetMyOnlineFriends(myFriends.filter((f) =>
          onlinePlayers.includes(f._id))); */}
          {/* playersWithin2.map((player) => ( */}
          {getPosition && (
            <PlayerMarkers
              playersWithin={playersWithin}
              player={player}
              handleSelectPlayer={handleSelectPlayer}
              now={now}
            />
          )}
          {filteredPostsComponents}
          {selectedPost ? (
            <Popup
              longitude={selectedPost.location.coordinates[0]}
              latitude={selectedPost.location.coordinates[1]}
              onClose={() => {
                setSelectedPost(null);
              }}
            >
              <div
              // className={`popup-inner ${darkTheme ? 'darkTheme' : ''}`}
              >
                <Link
                  to={`/post/${selectedPost._id}`}
                  className="mmenu_header hover3 no-underline black-link"
                >
                  <div className="flex-column">
                    <div className="padding-bottom postTop">
                      <div className="postTopLeft">
                        <span
                          className={
                            !mobileView ? 'postDate' : 'postDateMobile'
                          }
                        >
                          {preciseFormat(selectedPost?.createdAt)}
                        </span>
                        {selectedPost?.isPogw ? (
                          !mobileView ? (
                            <span className="pogwTitleSpan">
                              Proof of Great Work
                            </span>
                          ) : (
                            <span className="pogwTitleSpanMobile">POGW</span>
                          )
                        ) : null}
                      </div>
                      <div className="postTopRight"></div>
                    </div>
                    <div className="centered-text">
                      <h2>{selectedPost.playerId}</h2>
                      <p>"{selectedPost.desc}"</p>
                      <p>
                        {selectedPost?.location.address
                          ? selectedPost.location.address
                          : selectedPost.location?.coordinates
                          ? `Lat: ${selectedPost.location.coordinates[1]}, Lon: ${selectedPost.location.coordinates[0]}`
                          : 'Location not available'}
                      </p>{' '}
                    </div>
                  </div>
                </Link>
              </div>
              {selectedPost.img &&
              (selectedPost.img.endsWith('.mp4') ||
                selectedPost.img.endsWith('.mov')) ? (
                <video
                  width="100%"
                  src={selectedPost.img}
                  alt={selectedPost.desc}
                  title={selectedPost.desc}
                  controls
                  autoPlay
                  muted={false}
                />
              ) : (
                <img
                  width="100%"
                  src={
                    selectedPost.img
                      ? selectedPost.img
                      : 'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                  }
                  alt={selectedPost.desc}
                />
              )}
            </Popup>
          ) : null}
          {selectedPlayer ? (
            <Popup
              longitude={selectedPlayer.lastLocation.coordinates[0]}
              latitude={selectedPlayer.lastLocation.coordinates[1]}
              onClose={() => {
                setSelectedPlayer(null);
              }}
            >
              <div>
                <Link
                  to={`/profile/${selectedPlayer?.playerId}`}
                  className="mmenu_header hover3"
                >
                  <h2>{selectedPlayer.playerId}</h2>
                  <p>{selectedPlayer.desc}</p>
                </Link>
              </div>
              {selectedPlayer.coverPhoto &&
              (selectedPlayer.coverPhoto.endsWith('.mp4') ||
                selectedPlayer.coverPhoto.endsWith('.mov')) ? (
                <video
                  width="100%"
                  src={selectedPlayer.coverPhoto}
                  alt={selectedPlayer.playerId}
                  title={selectedPlayer.playerId}
                  controls
                  autoPlay
                  muted={false}
                />
              ) : (
                <img
                  width="100%"
                  src={
                    selectedPlayer.coverPhoto
                      ? selectedPlayer.coverPhoto
                      : 'https://gp1.wac.edgecastcdn.net/802892/http_public_production/profile_cover_photos/images/1242299/original/crop:x0y0w1920h746/quality:90/hash:1465227418/A-Screen_shot_2016-05-13_at_4.30.51_PM_copy.png?1465227418'
                  }
                  alt={selectedPlayer.playerId}
                />
              )}
            </Popup>
          ) : null}
        </ReactMapGL>
      </div>
    </>
  );
}
